import { request } from 'utils/request-utils';

import { propertyAssessmentUrl } from './urls';

export const fetchPropertyAssessment = photoSessionId =>
  request(propertyAssessmentUrl(photoSessionId));

export const fetchPropertyAssessmentEligibility = () => false;

export const savePropertyAssessment = (photoSessionId, body) =>
  request(propertyAssessmentUrl(photoSessionId),
    {
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        'Content-Type': 'application/json',
      },
    });
